// extracted by mini-css-extract-plugin
export var activeControls = "Embed-module--active-controls--02fa1";
export var captions = "Embed-module--captions--d5618";
export var consent = "Embed-module--consent--2d328";
export var iframeContainer = "Embed-module--iframe-container--c9def";
export var large = "Embed-module--large--beb8f";
export var medium = "Embed-module--medium--df077";